import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// primeReact
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
import { useAppContext } from "../../context/AppContext";
// components
import Panel from "../../components/panel/panel";
import ExportTable from "../../components/button/ExportButton";

export default function Pendencies() {
  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);
  const navigate = useNavigate();



  const items = [
    {
      template: () => (
        <Link to={"/pendencies"} className="p-breadcrumb-link">
          Pendências
        </Link>
      ),
    },
  ];
  const home = {
    icon: "fa fa-home",
  };
 // eslint-disable-next-line no-unused-vars
  const [visible, setVisible] = useState(true);
  // const [tableData, setTableData] = useState([]);

  const columns = [
    { field: "cod", header: "Nº Ficha" },
    { field: "cliente", header: "Imobiliaria" },
    { field: "cliente", header: "Cliente" },
    { field: "quadra", header: nomenclature[0].value },
    { field: "lote", header: nomenclature[0].value },
    { field: "parcela", header: "Parcelas" },
  ];

  const tableData = [
    { cod: "1", cliente: "Ana", quadra: "14", lote: "10", parcela: "220" },
  ];

  return (
    <>
      <div className="col-md-4">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <Panel title="Pendências">
        {visible && (
          <div>
            <hr className="my-4" />
            {/* <ExportTable
            // tableData={tableData}
            // exportColumns={exportColumns}
            // onGlobalFilterChange={onGlobalFilterChange}
            // globalFilterValue={globalFilterValue}
            /> */}
            <DataTable
              stripedRows
              showGridlines
              sortMode="multiple"
              selectionMode="single"
              value={tableData}
              paginator
              rows={5}
              sortableColumns={false}
              rowsPerPageOptions={[5, 25, 50]}
              // footerColumnGroup={footerGroup}
              // globalFilter={globalFilterValue}
              emptyMessage="Nenhuma Informação foi encontrada."
              tableStyle={{
                minWidth: "1rem",
                fontSize: "0.8rem",
                border: "0.8rem",
              }}
            >
              {columns.map((col) => (
                <Column
                  sortable
                  key={col.field}
                  field={col.field}
                  header={col.header}
                  // filterMatchMode={FilterMatchMode.CONTAINS}
                />
              ))}
              <Column
                header="Analisar Proposta"
                body={(rowData) => (
                  <div className="text-center">
                    <button
                      className="btn btn-success btn-btn-sm"
                      // onClick={() => setSelectedRow(rowData)}
                    >
                      <i className="fa-solid fa-arrow-up-right-from-square"></i>
                    </button>
                  </div>
                )}
              />
            </DataTable>
          </div>
        )}
      </Panel>
    </>
  );
}
